export default __webpack_public_path__ + "static/media/rewardlogo.387d0bc0.svg";